import { IComponentController } from 'angular';
import { IFormulaireGroupeAccordeonClass } from '../../../../../core/services/formulaire/formulaire-groupe-accordeon.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IFormulaireItemDividerClass } from '../../../../../core/services/formulaire/formulaire-item-divider.service';
import { IFormulaireItemSautDeLigneClass } from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { IFilterExDate } from '../../../../../core/filters/ex-date.filter';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IMenuItemForage, IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';
import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMenuItemEcranClass } from '../../../../../core/services/menu/menu-item-ecran.service';
import { IStateService } from 'angular-ui-router';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { INotificationHandler } from '../../../../../core/services/utils/notification-handler.service';
import { listeEtatsFinance } from '../../../../../core/constants/liste-etats-finance.constant';

interface IPageAc0010 extends IComponentController {
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    monoOccurrence: IMonoOccurrence;
    daiMultiOccurrenceOptions: IMultiOccurrenceOptions;
    daiMultiOccurrence: IMultiOccurrence;
    somMultiOccurrenceOptions: IMultiOccurrenceOptions;
    dcvMultiOccurrenceOptions: IMultiOccurrenceOptions;
    conMultiOccurrenceOptions: IMultiOccurrenceOptions;
    dacMenu: Array<IMenuItemForage>;
}

interface IAc0010Params {
    refcleint: string;
    intcleintreq: number;
    etrcleint: string;
    id: number;
    indfor: number;
    menuId: string;
    intcleint: number;
    etrcleintref?: string;
    typeCreation?: string;
}

/* @ngInject */
export default function Ac0010Controller(
    $stateParams: IAc0010Params,
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    FormulaireGroupeAccordeon: IFormulaireGroupeAccordeonClass,
    FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass,
    FormulaireItemDivider: IFormulaireItemDividerClass,
    Menu: IMenuClass,
    MenuItemForage: IMenuItemForageClass,
    MenuItemEcran: IMenuItemEcranClass,
    MenuItemAction: IMenuItemActionClass,
    exDateFilter: IFilterExDate,
    ecranDetails: IEcranDetailsResourcesEntite,
    notificationHandler: INotificationHandler,
    $state: IStateService,
    cp1010Route: IRoute,
    cp0005Route: IRoute,
    cp2010Route: IRoute,
    cp2014Route: IRoute,
    ac0032Route: IRoute,
    ac0028Route: IRoute,
    ac0041Route: IRoute,
    mc1012Route: IRoute,
    mc1014Route: IRoute,
    ac0022Route: IRoute,
    ac0055Route: IRoute,
    mc0044Route: IRoute,
    ac0072Route: IRoute,
    ac0076Route: IRoute,
    ac0073Route: IRoute,
    ac0025Route: IRoute,
    ac0056Route: IRoute,
    ac0057Route: IRoute,
    ac0033Route: IRoute) {

    const vm: IPageAc0010 = this;
    vm.valeursEcran = ecranDetails.valeurs;
    // LISTE DES BUTTONS
    vm.dacMenu = [
        new MenuItemAction(
            'LBL_BTN_FORMULAIRE_CEN',
            'BOUFORCEN',
            () => ({}),
            {
                iconButton: false,
                icon: 'print',
                fonction: 'BOUFORCEN',
                secondaire: true,
                formulaireConfirmationAction: {
                    lblTitre: 'LBL_BTN_FORMULAIRE_CEN',
                    lblConfirm: 'G_LBL_BTN_APPLIQUER',
                    largeurFormulaire: 30,
                    formulaire: new Formulaire([
                        new FormulaireItem('trlcodcen', { required: true })
                    ], {
                        largeurDefaut: 100,
                        securityCycle: false
                    })
                }
            }
        ),
        new MenuItemForage(
            'LBL_BTN_AVENANT',
            ac0076Route.NAME,
            (data: any) => ({
                daccleint: data.daccleint
            }),
            {
                fonction: 'BOUAVE',
                icon: 'exit_to_app',
                iconButton: false,
                secondaire: true,
                hidden: () => (vm.monoOccurrence.data.aut__dacflgave === 1)
            }
        ),
        new MenuItemAction(
            'LBL_BTN_CREER_AVENANT',
            'BOUCREAVE',
            () => ({}),
            {
                saveFirst: true,
                icon: 'exit_to_app',
                iconButton: false,
                secondaire: true,
                successAction: (retour: any) => {
                    $state.go(ac0073Route.NAME, {
                        id: retour.dcncleintnew,
                        daccleint: vm?.monoOccurrence?.data?.daccleint,
                        refcleint: vm?.monoOccurrence?.data?.refcleint,
                        menuId: $stateParams.menuId
                    });
                },
                hidden: () => (vm.monoOccurrence.data.aut__dacflgave !== 1)
            }
        ),
        new MenuItemForage(
            'LBL_BTN_HISTO_REC',
            ac0033Route.NAME,
            () => ({
                doccleintref: vm.monoOccurrence.data.doccleint,
                histo: true
            }),
            {
                fonction: 'BOUHISREC',
                iconButton: false,
                secondaire: true,
                icon: 'exit_to_app'
            }
        ),
        new MenuItemAction(
            'LBL_BTN_GEN_VENT',
            'BOUGENVNT',
            () => ({}),
            {
                iconButton: false,
                secondaire: true,
                icon: 'refresh',
                saveFirst: true,
                fonction: 'BOUGENVNT',
                messageConfirmation: 'BOUGENVEN_MESSAGE',
                successAction: () => { vm.monoOccurrence.fetchData(); },
                hidden: () => (!vm.monoOccurrence.data.aut__dacflggenimp)
            }
        ),
        new MenuItemForage(
            'LBL_IMPUTATION',
            ac0072Route.NAME,
            (data: any) => ({
                id: data.daccleint,
                daccleint: data.daccleint,
                indfor: $stateParams.indfor
            }),
            {
                icon: 'exit_to_app',
                iconButton: false,
                secondaire: true,
                fonction: 'BTNIMPUTATION'
            }
        ),
        new MenuItemAction(
            'LBL_BTN_DISTRI',
            'BOUDIS',
            () => ({}),
            {
                fonction: 'BOUDIS',
                icon: 'exit_to_app',
                iconButton: false,
                secondaire: true,
                hidden: (data: any) => (!data.affiche_distrib),
                successAction: (retour: any) => {
                    $state.go(getForageEcran(retour), getParamEcran(retour));// ac0056 || ac0057
                }
            }
        ),
        new MenuItemForage(
            'LBL_BTN_CLAUSE',
            ac0055Route.NAME,
            (data: any) => ({
                daccleint: data.daccleint,
                ajocleintref: data.daccleint,
                ecran: '01-2',
                id: data.daccleint,
                isforage: '1'
            }),
            {
                fonction: 'BOUCLA',
                icon: 'exit_to_app',
                secondaire: true,
                iconButton: false,
                compteur: () => (vm?.valeursEcran?.clausecompteur) ? vm?.valeursEcran?.clausecompteur : undefined,
                hidden: (data: any) => (!data.$id)
            }
        )
    ]
    const actionAdrRapide = new MenuItemAction(
        'LBL_BTN_ADR_RAPIDE',
        'BOUADRRAP',
        () => ({}),
        {
            icon: 'add_circle',
            fonction: 'BOUADRRAP',
            formulaireConfirmationAction: {
                lblTitre: 'LBL_BTN_ADR_RAPIDE',
                lblConfirm: 'G_LBL_BTN_APPLIQUER',
                largeurFormulaire: 30,
                formulaire: new Formulaire([
                    new FormulaireItem('radcodnew', { required: true }),
                    new FormulaireItem('radadrl01new', { required: true, maxlength: 40 }),
                    new FormulaireItem('radadrl02new', { maxlength: 40 }),
                    new FormulaireItem('radvilnew', { maxlength: 40 }),
                    new FormulaireItem('radpronew', { maxlength: 40 }),
                    new FormulaireItem('radpaynew', { maxlength: 40 }),
                    new FormulaireItem('radcodposnew', { maxlength: 10 }),
                    new FormulaireItem('radcodcednew', { maxlength: 40 })
                ], {
                    largeurDefaut: 100
                })
            },
            successAction: () => { vm.monoOccurrence.fetchData(); }
        }
    );

    const actionLieuPhyrec = new MenuItemAction(
        'LBL_BTN_LIEU_PHYSIQUE',
        'BOULIEPHY',
        () => ({
            type: 'REC'
        }),
        {
            icon: 'add_circle',
            fonction: 'BOULIEPHY',
            formulaireConfirmationAction: {
                lblTitre: 'LBL_BTN_LIEU_PHYSIQUE',
                lblConfirm: 'G_LBL_BTN_APPLIQUER',
                largeurFormulaire: 50,
                formulaire: new Formulaire([
                    new FormulaireItem('lipcodnew', { required: true }),
                    new FormulaireItem('lipflgadrfacnew'),
                    new FormulaireItem('lipnomnew', { required: true, maxlength: 80 }),
                    new FormulaireItem('lipnomabrnew', { maxlength: 30 }),
                    new FormulaireItem('intcleintnew'),
                    new FormulaireItemDivider('LBL_LIP_ADR'),
                    new FormulaireItem('lipadrl01new', { required: true, maxlength: 40 }),
                    new FormulaireItem('lipadrl02new', { maxlength: 40 }),
                    new FormulaireItem('lipvilnew', { maxlength: 40 }),
                    new FormulaireItem('lippronew', { maxlength: 40 }),
                    new FormulaireItem('lippaynew', { maxlength: 40 }),
                    new FormulaireItem('lipcodposnew', { maxlength: 10 }),
                    new FormulaireItem('lipflgquarecnew'),
                    new FormulaireItemDivider(''),
                    new FormulaireItem('lipnumtelnew', { maxlength: 14 }),
                    new FormulaireItem('lipnumtelposnew', { maxlength: 7 }),
                    new FormulaireItem('lipnumfaxnew', { maxlength: 14 }),
                    new FormulaireItem('lipadrcounew', { maxlength: 60 }),
                    new FormulaireItem('lipcleintrefnew')
                ], {
                    largeurDefaut: 50
                })
            },
            successAction: () => { vm.monoOccurrence.fetchData(); }
        }
    );

    const actionLieuPhyfac = new MenuItemAction(
        'LBL_BTN_LIEU_PHYSIQUE',
        'BOULIEPHY',
        () => ({
            type: 'FAC'
        }),
        {
            icon: 'add_circle',
            fonction: 'BOULIEPHYFAC',
            formulaireConfirmationAction: {
                lblTitre: 'LBL_BTN_LIEU_PHYSIQUE',
                lblConfirm: 'G_LBL_BTN_APPLIQUER',
                largeurFormulaire: 50,
                formulaire: new Formulaire([
                    new FormulaireItem('lipcodnew', { required: true }),
                    new FormulaireItem('lipflgadrfacnew'),
                    new FormulaireItem('lipnomnew', { required: true, maxlength: 80 }),
                    new FormulaireItem('lipnomabrnew', { maxlength: 30 }),
                    new FormulaireItem('intcleintnew'),
                    new FormulaireItemDivider('LBL_LIP_ADR'),
                    new FormulaireItem('lipadrl01new', { required: true, maxlength: 40 }),
                    new FormulaireItem('lipadrl02new', { maxlength: 40 }),
                    new FormulaireItem('lipvilnew', { maxlength: 40 }),
                    new FormulaireItem('lippronew', { maxlength: 40 }),
                    new FormulaireItem('lippaynew', { maxlength: 40 }),
                    new FormulaireItem('lipcodposnew', { maxlength: 10 }),
                    new FormulaireItem('lipflgquarecnew'),
                    new FormulaireItemDivider(''),
                    new FormulaireItem('lipnumtelnew', { maxlength: 14 }),
                    new FormulaireItem('lipnumtelposnew', { maxlength: 7 }),
                    new FormulaireItem('lipnumfaxnew', { maxlength: 14 }),
                    new FormulaireItem('lipadrcounew', { maxlength: 60 }),
                    new FormulaireItem('lipcleintrefnew')
                ], {
                    largeurDefaut: 50
                })
            },
            successAction: () => { vm.monoOccurrence.fetchData(); }
        }
    );

    const actionRef = [
        new MenuItemAction(
            'LBL_BTN_CHGREF',
            'BOUCHGREF',
            () => ({}),
            {
                icon: 'change_circle',
                fonction: 'BOUCHGREF',
                formulaireConfirmationAction: {
                    lblTitre: 'LBL_BTN_CHGREF',
                    lblConfirm: 'G_LBL_BTN_APPLIQUER',
                    largeurFormulaire: 30,
                    formulaire: new Formulaire([
                        new FormulaireItem('textaffichage', {
                            titre: ' ',
                            readonly: true,
                            default: vm.valeursEcran.textaffichage
                        }),
                        new FormulaireItem('refcleintnew', {
                            required: true
                        })
                    ], {
                        largeurDefaut: 100
                    })
                },
                successAction: () => { vm.monoOccurrence.fetchData(); },
                hidden: () => (vm.monoOccurrence.data.etrcleint || !vm.monoOccurrence.data.$id)
            }
        ),
        new MenuItemForage(
            'BTN_FORAGE_PFL',
            cp0005Route.NAME,
            (data: any) => ({
                id: data.foucleint
            }),
            {
                fonction: 'BOUENTPYM',
                icon: 'exit_to_app'
            }
        )
    ];

    const actionsApo = [
        new MenuItemForage(
            'BTN_FORAGE_APO',
            ac0028Route.NAME,
            (data: any) => ({
                id: data.aut__doccleintapo
            }),
            {
                icon: 'exit_to_app',
                iconButton: true,
                fonction: 'BOUAPO',
                hidden: (data: any) => (!vm.monoOccurrence.data.$id || !data.apocleint)
            }
        ),
        new MenuItemAction(
            'LBL_BTN_CHGAPO',
            'BOUCHGAPO',
            () => ({}),
            {
                icon: 'change_circle',
                disabled: (data: any) => data.display,
                fonction: 'BOUCHGAPO',
                formulaireConfirmationAction: {
                    lblTitre: 'LBL_BTN_CHGAPO',
                    lblConfirm: 'G_LBL_BTN_APPLIQUER',
                    largeurFormulaire: 30,
                    formulaire: new Formulaire([
                        new FormulaireItem('apocleint', {
                            readonly: true,
                            disabled: true
                        }),
                        new FormulaireItem('apocleintnew', {
                            required: false,
                            resourceParams: (data: any) => ({
                                refcleint: data.refcleint
                            }),
                        })
                    ], {
                        largeurDefaut: 100
                    })
                },
                successAction: () => { vm.monoOccurrence.fetchData(); },
                hidden: () => (!vm.monoOccurrence.data.$id)
            }
        )
    ];

    const actionMsg = [
        new MenuItemAction(
            'LBL_BTN_DACMSG',
            'BOUDACMSG',
            () => ({}),
            {
                icon: 'description',
                class: (data: any) => (data?.dacmsg) ? 'ex-teal-500-bg' : 'ex-primary-hue-3-fg',
                fonction: 'BOUDACMSG',
                formulaireConfirmationAction: {
                    lblTitre: 'LBL_BTN_DACMSG',
                    lblConfirm: 'G_LBL_BTN_APPLIQUER',
                    largeurFormulaire: 30,
                    noUpdateFromParent: true,
                    formulaire: new Formulaire([
                        new FormulaireItem('dacmsg', {
                            default: (data: any) => data.dacmsg,
                            readonly: (data: any) => (!data.aut__dacflgmodpos),
                        })
                    ], {
                        largeurDefaut: 100
                    })
                },
                successAction: () => { vm.monoOccurrence.fetchData(); },
            }
        ),
        new MenuItemAction(
            'LBL_BTN_DACMSGCOU',
            'BOUDACMSGCOU',
            () => ({}),
            {
                icon: 'mail',
                class: (data: any) => (data.mcmdsc && data.aut__flgmsgcou) ? 'ex-teal-500-bg' : 'ex-primary-hue-3-fg',
                fonction: 'BOUDACMSGCOU',
                formulaireConfirmationAction: {
                    lblTitre: 'LBL_BTN_DACMSGCOU',
                    lblConfirm: 'G_LBL_BTN_APPLIQUER',
                    largeurFormulaire: 30,
                    formulaire: new Formulaire([
                        new FormulaireItem('dacmsgcounew', {
                            default: (data: any) => (data.aut__flgmsgcou) ? data.mcmdsc : null,
                            readonly: (data: any) => (!data.aut__dacflgmodpos),
                        })
                    ], {
                        largeurDefaut: 100
                    })
                },
                successAction: () => { vm.monoOccurrence.fetchData(); }
            }
        )
    ];

    const forageEnt = [
        new MenuItemForage(
            'BTN_FORAGE_PFL',
            cp1010Route.NAME,
            (data: any) => ({
                entcleint: data.entcleint,
                ecran: '00-2',
            }),
            {
                hidden: (data: any) => (!data.entcleint || !data.$id),
                fonction: 'BOUENTPAI',
                icon: 'exit_to_app'
            }
        )
    ];

    const forageDpf = [
        new MenuItemForage(
            'BTN_FORAGE_DPF',
            ac0041Route.NAME,
            (data: any) => ({
                id: data.aut__doccleintdpf
            }),
            {
                hidden: (data: any) => (!data.aut__doccleintdpf || !data.$id),
                fonction: 'BOUDPF',
                icon: 'exit_to_app'
            }
        )
    ];

    const docConsomme = [
        new MenuItemForage(
            'BTN_DOC_CONSOMME',
            (rowData: any) => getForageItem(rowData),
            (rowData: any) => getParamItem(rowData),
            {
                icon: 'exit_to_app',
                iconButton: true,
                fonction: 'BOUDOCCON'
            }
        )
    ];

    const ajoutFca = [
        new MenuItemAction(
            'LBL_BTN_AJOFCA',
            'BOUFCA',
            () => ({}),
            {
                icon: 'mode_edti',
                fonction: 'BOUFCA',
                formulaireConfirmationAction: {
                    lblTitre: 'LBL_BTN_AJOFCA',
                    lblConfirm: 'G_LBL_BTN_APPLIQUER',
                    largeurFormulaire: 30,
                    formulaire: new Formulaire([
                        new FormulaireItem('fcacleintnew', {
                            resourceParams: (data: any) => ({
                                dacdat: data.dacdat
                            })
                        })
                    ], {
                        largeurDefaut: 100
                    })
                },
                successAction: () => { vm.monoOccurrence.fetchData(); },
                hidden: () => (!vm.monoOccurrence.data.$id)
            }
        )
    ];
    vm.monoOccurrenceOptions = {
        cycleEvenementSecurityChampsModifiables: {
            active: true,
            //on peut ajouter plusieurs etats en les séparant par des virgules
            etatsCycle: `${listeEtatsFinance.officiel}`
        },
        fonctions: {
            boutonDupliquer: false,
            //edition: vm.valeursEcran.updat_dac
        },
        infosMonetaires: {
            blocs: ['dai', 'dcv'],
            largeurTexte: 150,
            donnees:
                [
                    { nom: 'dai', libelle: 'LBL_MNT_DAI' },
                    { nom: 'dcv', libelle: 'LBL_MNT_DCV' },
                    { nom: 'net', libelle: 'LBL_MNT_NET' },
                    { nom: 'eng', libelle: 'LBL_MNT_ENG' },
                    { nom: 'dev', libelle: 'LBL_TAU_DEV' },
                ]
        },
        cycleRoutesActionPossibles: {
            route: ac0033Route,
            parametres: [
                {
                    colonne: 'doccleintref',
                    value: vm?.valeursEcran?.doccleintref
                },
                {
                    colonne: 'menuId',
                    value: $stateParams.menuId
                }
            ],
            action: 'A190'
        },
        infosFinancieres: {
            disponibilite: vm.valeursEcran.disp_sec,
            impactFinancier: false,
            impactBudgetaire: vm.valeursEcran.imp_budj
        },
        cycleFinancesValeursDefaut: () => ({ peccleint__peccod: vm.valeursEcran.peccleint_avn, peccleint: vm.valeursEcran.peccleint_cle }),
        actionsMore: new Menu([
            new MenuItemAction(
                'LBL_BTN_REO',
                'BOUREO',
                () => ({}),
                {
                    iconButton: false,
                    icon: 'file_open',
                    saveFirst: true,
                    fonction: 'BOUREO',
                    successAction: () => { window.location.reload(); },
                    hidden: (data: any) => (vm.monoOccurrence.data.aut__dacflgreo || !data.$id)
                }
            ),
            new MenuItemEcran(
                'LBL_BTN_HISTO_IMP',
                ac0022Route.NAME,
                (data: any) => ({
                    dhicleintref: data.doccleint,
                    dhityp: 'DOC'
                }),
                {
                    icon: 'launch',
                    iconButton: false,
                    fonction: 'BOUHISIMP',
                    hidden: (data: any) => (!data.$id)
                }
            ),
            new MenuItemEcran(
                'LBL_TOLERANCE',
                mc1014Route.NAME,
                (data: any) => ({
                    tolcleintref: data.daccleint,
                    vaeustent: 'DAC'
                }),
                {
                    fonction: 'BOUTOL',
                    icon: 'data_usage',
                    iconButton: false,
                    hidden: (data: any) => (!data.$id)
                }
            ),
            new MenuItemForage(
                'LBL_BTN_HISTO_RELANCE',
                ac0025Route.NAME,
                (data: any) => ({
                    id: data.daccleint,
                    daccleint: data.daccleint
                }),
                {
                    fonction: 'BOUHISREL',
                    iconButton: false,
                    secondaire: true,
                    icon: 'exit_to_app'
                }
            )
        ]),
        formulaire: new Formulaire('LBL_BLC_DAC', [
            new FormulaireItem('dacnumdoc'),
            new FormulaireItem('dacnumdocseq'),
            new FormulaireItem('sysboncmd'),
            new FormulaireItem('tydcleint'),
            new FormulaireItem('dacdatbc'),
            new FormulaireItem('dacseqave'),
            new FormulaireItem('peccleint'),
            new FormulaireItem('dacdat', { default: exDateFilter(new Date()) }),
            new FormulaireItem('dacdatreq'),
            new FormulaireItem('refcleint', { default: $stateParams.refcleint, largeur: 66.66, menu: actionRef }),
            new FormulaireItem('etrcleint', { default: $stateParams.etrcleint || ($stateParams.typeCreation === 'ent' ? $stateParams.etrcleintref : undefined) }),
            new FormulaireItem('intcleint'),
            new FormulaireItem('intcleintdem'),
            new FormulaireItem('dacrefint'),
            new FormulaireItem('dacdsc', { largeur: 66.66, enableCount: true, menu: actionMsg }),
            new FormulaireItem('dacsou'),
            new FormulaireItem('caacleint', {
                resourceParams: (data: any) => ({
                    refcleint: data.refcleint
                })
            }),
            new FormulaireItem('aut__dpfnumdoc', { menu: forageDpf }),
            new FormulaireItem('dacflgpij'),
            new FormulaireItem('vaesysdevcod'),
            new FormulaireItem('devtaucou'),
            new FormulaireGroupeAccordeon('LBL_GRP_ADR',
                new Formulaire([
                    new FormulaireItem('radcleint', {
                        menu: [actionAdrRapide],
                        readonly: (data: any) => !vm.valeursEcran.rad_aff,
                        resourceParams: (data: any) => ({
                            refcleint: data.refcleint,
                            dacdat: data.dacdat
                        })
                    }),
                    new FormulaireItem('lipcleint', { menu: [actionLieuPhyrec], readonly: !vm.valeursEcran.lip_aff }),
                    new FormulaireItem('lipcleintfac', { menu: [actionLieuPhyfac] }),
                    new FormulaireItem('dacattext', { readonly: !vm.valeursEcran.dac_ach_aff }),
                    new FormulaireItem('dacatt', { readonly: !vm.valeursEcran.dac_recp_aff })
                ], { largeurDefaut: 33.33 })
            ),
            new FormulaireGroupeAccordeon('LBL_GRP_MOD',
                new Formulaire([
                    new FormulaireItemDivider('LBL_DIV_MODACH'),
                    new FormulaireItem('cfncleint', {
                        resourceParams: (data: any) => ({
                            refcleint: data.refcleint,
                            dacdat: data.dacdat
                        })
                    }),
                    new FormulaireItem('intcleintach'),
                    new FormulaireItem('apocleint', {
                        readonly: !vm.valeursEcran.dac_apo_aff,
                        resourceParams: (data: any) => ({
                            refcleint: data.refcleint
                        }),
                        menu: actionsApo,
                        disabled: (data: any) => data.display
                    }),
                    new FormulaireItem('iaccleint'),
                    new FormulaireItem('intcleintins'),
                    new FormulaireItem('dacins'),
                    new FormulaireItem('motcleint', { readonly: !vm.valeursEcran.dac_mot_aff }),
                    new FormulaireItemDivider('LBL_DIV_MODFAC'),
                    new FormulaireItem('vecsysmodtra'),
                    new FormulaireItem('dacindfrsacc', { default: 1 }),
                    new FormulaireItem('teccleint', {
                        readonly: !!vm.valeursEcran.tecc_aff
                    }),
                    new FormulaireItem('aut__fcanum', { menu: ajoutFca }),
                    new FormulaireItem('mopcleint', { readonly: !vm.valeursEcran.dac_mop_aff }),
                    new FormulaireItem('entcleint', { menu: forageEnt, readonly: !vm.valeursEcran.dac_ent_aff }),
                    new FormulaireItemDivider('LBL_DIV_AUTRES'),
                    new FormulaireItem('vecdaccat'),
                    new FormulaireItem('dacnumrescd', {
                        menu: [
                            new MenuItemEcran('LBL_HISTO_RESOL',
                                mc1012Route.NAME,
                                (data: any) => ({ doccleintref: data.daccleint }),
                                {
                                    icon: 'launch',
                                    iconButton: true,
                                    fonction: 'BOUHISRES'
                                }
                            )
                        ]
                    }
                    ),
                    new FormulaireItem('dacnumresca'),
                    new FormulaireItem('vecsystercom', {
                        readonly: !vm.valeursEcran.dac_vecsy_aff
                    }),
                    new FormulaireItem('dacdes'),
                    new FormulaireItem('lolcleint'),
                    new FormulaireItem('dacdatree'),
                    new FormulaireItem('dacdatdeb'),
                    new FormulaireItem('dacdatfin'),
                    new FormulaireItem('intcleint_averti'),
                    new FormulaireItem('aut__founomabr'),
                    new FormulaireItemSautDeLigne,
                    new FormulaireItem('dacdetexp', { largeur: 100, enableCount: true })
                ], { largeurDefaut: 33.33 })
            )
        ], { largeurDefaut: 33.33 }),
        successActionSauvegarde: () => {
            vm.monoOccurrence.fetchData();
        }
    };
    vm.daiMultiOccurrenceOptions = {
        bloc: 'dai',
        actionsMore: new Menu([
            new MenuItemAction(
                'LBL_BTN_RENUM',
                'BOURENUM',
                () => ({}),
                {
                    iconButton: false,
                    icon: 'refresh',
                    fonction: 'BOURENUM',
                    formulaireConfirmationAction: {
                        lblTitre: 'LBL_BTN_RENUM',
                        lblConfirm: 'G_LBL_BTN_APPLIQUER',
                        largeurFormulaire: 30,
                        formulaire: new Formulaire([
                            new FormulaireItem('pasde', {
                                required: true,
                                default: 1
                            })
                        ])
                    },
                    successAction: () => { vm.daiMultiOccurrence.fetchDataList(); },
                    hidden: () => !(vm.monoOccurrence.data.aut__dacflgmodpos)
                }
            ),
            new MenuItemForage(
                'LBL_BTN_SOMMAIRE_ITEM',
                ac0032Route.NAME,
                (data: any) => ({
                    daccleint: data.daccleint,
                    effacercriteres: 1,
                    isforage: 1
                }),
                {
                    fonction: 'BOUSOMITE',
                    icon: 'exit_to_app'
                }
            )
        ]),
        editionRapideActive: vm.valeursEcran.update_allowed,
        fonctions: {
            editionRapide: vm.valeursEcran.update_allowed,
            editionStandard: true,
            agrandirMultiOccurrence: true,
            edition: vm.valeursEcran.update_allowed,
            nouveau: vm.valeursEcran.insert_alowed,
            supprime: vm.valeursEcran.update_allowed
        },
        colonnesFixesGauche: [
            { nom: 'dailig', largeur: 150 },
            { nom: 'dailigseq', largeur: 65 },
            { nom: 'daiseqave', largeur: 65 },
            { nom: 'daidsc', largeur: 300 }
        ],
        colonnesVisibles: [
            {
                nom: 'daidsclng', largeur: 120,
                isIcon: [{
                    value: '',
                    toujoursVisible: true,
                    indicateurDeDonnees: true,
                    iconIndicateurClass: 'ex-grid-col-setColorVert ex-input-description-bouton-texte-long',

                    icon: "description",
                    iconTitleData: true,
                    iconTitleChamp: 'daidsclng',
                    iconClass: 'ex-input-description-bouton-texte-long',
                    iconAfficherTooltip: true,

                    hasLibelle: true,
                    champLibelle: "",
                    constantLibelle: "daidsclng",
                    hasModal: true
                }]
            },
            { nom: 'daiprxuni', largeur: 120 },
            { nom: 'daiqte', largeur: 120 },
            { nom: 'taxcod', largeur: 80 },
            { nom: 'daimnt', largeur: 120 },
            { nom: 'daimnttaxfed', largeur: 130 },
            { nom: 'daimnttaxpro', largeur: 130 },
            { nom: 'caacod', largeur: 140 },
            { nom: 'caadsc', largeur: 180 },
            { nom: 'dainumcat', largeur: 150 },
            { nom: 'forcod', largeur: 120 },
            { nom: 'fordsc', largeur: 180 },
            { nom: 'unmcod', largeur: 130 },
            { nom: 'unmdsc', largeur: 180 },
            { nom: 'daiclash', largeur: 140 },
            { nom: 'daipayori', largeur: 140 },
            { nom: 'lolnumloc', largeur: 120 },
            { nom: 'loldsc', largeur: 180 },
            { nom: 'daiflggeb', largeur: 120 }
        ],
        colonnesFixesDroite: [
            { nom: 'daiflghis', largeur: 80 },
            { nom: 'flgimp', largeur: 80 },
            { nom: 'daiflgimp', largeur: 110 }
        ],
        colonnesEditionRapide: [
            { nom: 'dailig', largeur: 150 },
            { nom: 'daidsc', largeur: 100 },
            { nom: 'daidsclng', largeur: 110 },
            { nom: 'daiprxuni', largeur: 120 },
            { nom: 'daiqte', largeur: 120 },
            { nom: 'taxcleint', largeur: 150 },
            { nom: 'daimnt', largeur: 120 },
            { nom: 'daimnttaxfed', largeur: 140 },
            { nom: 'daimnttaxpro', largeur: 140 },
            { nom: 'caacleint', largeur: 150 },
            { nom: 'dainumcat', largeur: 140 },
            { nom: 'forcleint', largeur: 120 },
            { nom: 'daiclash', largeur: 140 },
            { nom: 'daipayori', largeur: 120 },
            { nom: 'lolcleint', largeur: 120 },
            { nom: 'daiflggeb', largeur: 120 },
            { nom: 'daiflghis', largeur: 120 },
            { nom: 'flgimp', largeur: 80 },
            { nom: 'daiflgimp', largeur: 120 }
        ],
        colonnesCachees: ['edecleint', 'forcod_aut', 'dainum_aut', 'daiprx_aut', 'daidsc_upt', 'catal_disa', 'format_disa', 'daiprx_disa'],
        formulaire: new Formulaire([
            new FormulaireItem('dailig', { activerCompteur: { activerCompteur: true, function: 'BOUITEMCOUNTER' } }),
            new FormulaireItem('edecleint', {
                resourceParams: (data: any) => ({
                    etrcleint: data.$ancetre.etrcleint,
                    dacdat: data.$ancetre.dacdat,
                }),
                cssFormulaire: (data: any) => 'form-field-hidden'
            }),
            new FormulaireItem('daidsc', {
                focusOnNew: true,
                champsItemCatalogue: {
                    colonneDescription: 'daidsc', colonneNumCatalogue: 'dainumcat'
                    , colonnePrixUnitaire: 'daiprxuni', idEntente: "edecleint", champsDescriptionEntente: ['edeitmdsc']
                    , doccleint: $stateParams.id
                },
                readonly: (rowData: any) => (!vm.valeursEcran.update_allowed || (rowData?.daidsc_upt)),
                required: true
            }),
            new FormulaireItem('daidsclng', {
                affichageBoutonTexteLong: {
                    active: true,
                    modaleOptions: {
                        titre: 'G_LBL_TITRE_MODAL_TEXTE_LONG_AC0010',
                        icon: 'article',
                        largeur: 50
                    },
                    champOptions: {
                        enableCount: true,
                        largeur: 100,
                        showTooltip: true
                    }
                }
            }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('daiprx_disa', {
                hidden: true,
                default: 0
            }),
            new FormulaireItem('daiprxuni', {
                readonly: (rowData: any) => rowData?.daiprx_aut || rowData.daiprx_disa,
                //  disabled: (data: any) => data.daiprx_disa
            }),
            new FormulaireItem('daiqte'),
            new FormulaireItem('taxcleint'),
            new FormulaireItem('daimnt'),
            new FormulaireItem('daimnttaxfed'),
            new FormulaireItem('daimnttaxpro'),
            new FormulaireItem('daimntnet'),
            new FormulaireItem('caacleint'),
            new FormulaireItem('dainumcat', {
                readonly: (rowData: any) => rowData?.dainum_aut || rowData.catal_disa
            }),
            new FormulaireItem('forcleint', {
                readonly: (rowData: any) => rowData?.forcod_aut || rowData.format_disa
            }),
            new FormulaireItem('daiclash'),
            new FormulaireItem('daipayori'),
            new FormulaireItem('lolcleint'),
            new FormulaireItem('daiflggeb'),
            new FormulaireItem('daiflghis'),
            new FormulaireItem('daiflgimp', { default: 1 })
        ], { largeurDefaut: 33.33 })
    };
    vm.dcvMultiOccurrenceOptions = {
        bloc: 'dcv',
        fonctions: {
            supprime: false,
            boutonDupliquer: vm.valeursEcran.dac_venti
        },
        colonnesFixesGauche: [
            {
                nom: 'dcvimp', largeur: 300, menu: [
                    new MenuItemEcran(
                        '',
                        mc0044Route.NAME,
                        (rowData: any) => ({
                            id: rowData.prucleint,
                            prucleint: rowData.prucleint
                        }),
                        {
                            icon: 'launch',
                            iconButton: false,
                            secondaire: true,
                            fonction: 'BOUPOS'
                        })
                ]
            },
            { nom: 'dcvmnt', largeur: 180 }
        ],
        colonnesVisibles: [
            { nom: 'dcvqte', largeur: 100 },
            { nom: 'taxcod', largeur: 100 },
            { nom: 'remcod', largeur: 100 },
            { nom: 'dcvmnttaxfed', largeur: 130 },
            { nom: 'dcvmnttaxpro', largeur: 130 },
            { nom: 'dcvmntremfed', largeur: 130 },
            { nom: 'dcvmntrempro', largeur: 130 },
            { nom: 'dcvmntdepnet', largeur: 130 },
            { nom: 'dcvseqave', largeur: 100 },
            { nom: 'dcvdsc', largeur: 180 }
        ],
        colonnesFixesDroite: [
            { nom: 'dcvflgmsg', largeur: 100 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('dcvimp', { hidden: true }),
        ]),
        colonnesCachees: [
            'dcvmsg',
            'prucleint'
        ]
    };

    vm.somMultiOccurrenceOptions = {
        reloadWithBlocs: ['DAI'],
        fonctions: {
            supprime: false,
            nouveau: false,
            edition: false
        },
        colonnesFixesGauche: [
            { nom: 'dailig', largeur: 100 },
            { nom: 'daidsc', largeur: 250 }
        ],
        colonnesVisibles: [
            { nom: 'daidsclng', largeur: 250 },
            { nom: 'daiprxuni', largeur: 120 },
            { nom: 'daiqte', largeur: 120 },
            { nom: 'taxcod', largeur: 80 },
            { nom: 'daimnt', largeur: 120 },
            { nom: 'daimnttaxfed', largeur: 130 },
            { nom: 'daimnttaxpro', largeur: 130 },
            { nom: 'caacod', largeur: 140 },
            { nom: 'caadsc', largeur: 180 },
            { nom: 'dainumcat', largeur: 150 },
            { nom: 'forcod', largeur: 120 },
            { nom: 'fordsc', largeur: 180 },
            { nom: 'unmcod', largeur: 130 },
            { nom: 'unmdsc', largeur: 180 },
            { nom: 'daiclash', largeur: 140 },
            { nom: 'daipayori', largeur: 140 },
            { nom: 'lolnumloc', largeur: 120 },
            { nom: 'loldsc', largeur: 180 },
            { nom: 'daiflggeb', largeur: 120 }
        ]
    };

    vm.conMultiOccurrenceOptions = {
        bloc: 'con',
        fonctions: {
            supprime: false,
            nouveau: false,
            edition: false
        },
        colonnesFixesGauche: [
            { nom: 'docnumdoc', largeur: 150, menu: docConsomme }
        ],
        colonnesVisibles: [
            { nom: 'tydcod', largeur: 100 },
            { nom: 'tyddsc', largeur: 200 },
            { nom: 'docdat', largeur: 126 },
            { nom: 'docmnt', largeur: 120 },
            { nom: 'docmntcon', largeur: 120 },
            { nom: 'refcod', largeur: 120 },
            { nom: 'refnom', largeur: 200 },
            { nom: 'reqcod', largeur: 120 },
            { nom: 'reqnom', largeur: 200 }
        ],
        colonnesCachees: [
            'ecrcod',
            'doccleintcon',
            'docaffcleint'
        ]
    };
    function getForageItem(rowData: any): string {
        if (rowData.ecrcod === 'CP0013-00-2') {
            return cp2010Route.NAME;
        } else if (rowData.ecrcod === 'CP0014-00') {
            return cp2014Route.NAME;
        }
    }
    function getParamItem(rowData: any) {
        if (['CP0013-00-2', 'CP0013-00'].includes(rowData.ecrcod)) {
            return { id: rowData.doccleintcon };
        } else if (['CP0014-00'].includes(rowData.ecrcod)) {
            return { id: rowData.docaffcleint };
        }
    }

    function getForageEcran(retour: any): string {
        if (retour.tecflgfac === 1) {
            return ac0057Route.NAME;

        } else {
            return ac0056Route.NAME;
        }
    }
    function getParamEcran(retour: any) {
        if (retour.tecflgfac === 1) {
            return {
                id: retour.daccleintnew
            }
        } else {
            return {
                id: retour.docidnew,
                daccleint: retour.daccleintnew,
                dndrefintnew: retour.dndrefintnew,
                intnomnew: retour.intnomnew,
                lolcleintnew: retour.lolcleintnew,
                menuId: $stateParams.menuId
            };
        }
    }
}
